import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { STORAGE_USER } from '../../constants/storage';

export const NotFound = () => {
  const hasUser = Boolean(localStorage.getItem(STORAGE_USER));

  return (
    <Box
      sx={{
        maxWidth: 420,
        mx: 'auto',
        px: 3,
        py: 6,
        textAlign: 'center',
      }}
    >
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
        <img src="/lucky-logo.svg" alt="Lucky Services" />
      </Box>
      <Typography variant="h1" component="h1" sx={{ mb: 2 }}>
        Page not found
      </Typography>
      <Typography sx={{ mb: 3, color: '#455445' }}>
        The page you are looking for does not exist or may have moved.
      </Typography>
      <Button
        component={RouterLink}
        to={hasUser ? '/dashboard' : '/login'}
        variant="contained"
      >
        {hasUser ? 'Go to Dashboard' : 'Go to Login'}
      </Button>
    </Box>
  );
};
